<!-- 学校-引入课程 -->
<template>
  <div class="container">
    <div class="index" v-if="!detail.show">
      <div class="title">
        <div class="span1">
          <span>{{ $route.name }}</span>
        </div>
      </div>

      <div class="selectBox">
        <div class="selectRow">
          <div class="selectLable">课程类型:</div>
          <div
            :class="['selectItem', { on: it.val == queryParams.typeId }]"
            v-for="(it, index) in courseTypeList"
            :key="index"
            @click="courseTypeClick(it)"
          >
            {{ it.lable }}
          </div>
        </div>
        <div class="selectRow">
          <div class="selectLable">适用年级:</div>
          <div
            :class="['selectItem', { on: it.val == queryParams.scope }]"
            v-for="(it, index) in gradeList"
            :key="index"
            @click="gradeClick(it)"
          >
            {{ it.lable }}
          </div>
        </div>
        <div class="selectRow">
          <div class="selectLable">课程专题:</div>
          <div
            :class="['selectItem', { on: it.val == queryParams.project }]"
            v-for="(it, index) in courseSpecialList"
            :key="index"
            @click="courseSpecialClick(it)"
          >
            {{ it.lable }}
          </div>
        </div>
      </div>
      <div class="tab_box">
        <div class="selectRow">
          <div
            :class="['selectItem', { on: it.val == queryParams.cost }]"
            v-for="(it, index) in tabList"
            :key="index"
            @click="tabClick(it)"
          >
            {{ it.lable }}
          </div>
          <div class="count">
            共 <span>{{ totalPage }}</span> 个资源
          </div>
        </div>
      </div>

      <div
        class="course_box"
        v-if="courseList && Object.keys(courseList).length"
      >
        <div class="course_item" v-for="(it, index) in courseList" :key="index">
          <img
            v-if="it.recommend == '1'"
            class="recommend"
            :src="recommendUrl"
            alt=""
          />
          <div style="font-size: 0; cursor: pointer" @click="toDetail(it)">
            <img :src="it.coverUrl" alt="" />
          </div>
          <div class="course_info">
            <div class="title">{{ it.cname }}</div>
            <p>{{ it.description }}</p>
            <div class="play">
              <span class="play_time">{{ it.periodTotal }}课时/学年</span>
              <span class="play_status">{{
                it.price > 0 ? it.price : "免费"
              }}</span>
            </div>
            <div class="jion_btn" @click="importFun(it)">
              <template v-if="it.introduceState == '0'">
                <img src="@/assets/img/jia.svg" alt="" />
                <span style="color: #40a3ff">引入课程</span>
              </template>
              <template v-else>
                <img src="@/assets/img/jian.svg" alt="" />
                <span style="color: #cdcdcd">取消引入</span>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <img class="no_data" src="@/assets/img/no_data.svg" alt="" />
      </div>
      <div class="pagination">
        <el-pagination
          background
          :current-page="pageNum"
          :page-sizes="[8, 20, 50, 100]"
          :page-size="pageSize"
          :total="totalPage"
          layout="total,prev, pager, next,jumper,sizes"
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
        ></el-pagination>
      </div>
    </div>
    <Detail
      :info.sync="detail.info"
      v-show="detail.show"
      @to-index="toIndex"
      @importFun="importFun"
      :introduceState="introduceState"
    ></Detail>
  </div>
</template>
<script>
import schoolApi from "@/api/schoolApi/index.js";
import { getDetail } from "@/api/mechanismApi/curriculum.js";
import util from "@/utils/util.js";
import dayjs from "dayjs";
import _ from "lodash";
import { schoolTeacherList } from "@/api/user/userCenter";
import educationApi from "@/api/education/index.js";
export default {
  components: {
    Detail: () => import("./detail.vue"),
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 8,
      totalPage: 0,
      queryParams: {
        typeId: "all",
        scope: "all",
        project: "all",
        cost: "all",
      },
      noData: false,
      stateObj: {
        0: "未送审",
        1: "待审核",
        2: "已审核通过",
        3: "审核失败",
      },
      detail: {
        info: {},
        show: false,
      },
      introduceState: "",
      recommendUrl: require("@/assets/img/recommend.svg"),
      importType: "single",
      typeIndex1: "0",
      typeIndex2: "",
      typeIndex3: "0",
      tabIndex: "1",
      courseTypeList: [
        { lable: "全部", val: "all" },
        { lable: "德育", val: "103" },
        { lable: "智育", val: "102" },
        { lable: "体育", val: "104" },
        { lable: "美育", val: "101" },
        { lable: "劳育", val: "105" },
      ],
      gradeList: [
        { lable: "全部", val: "all" },
        { lable: "一年级", val: "01" },
        { lable: "二年级", val: "02" },
        { lable: "三年级", val: "03" },
        { lable: "四年级", val: "04" },
        { lable: "五年级", val: "05" },
        { lable: "六年级", val: "06" },
        { lable: "七年级", val: "11" },
        { lable: "八年级", val: "12" },
        { lable: "九年级", val: "13" },
      ],
      courseSpecialList: [
        { lable: "全部", val: "all" },
        { lable: "精品慕课", val: "0" },
        { lable: "赛事活动", val: "1" },
        { lable: "非遗文化", val: "2" },
      ],
      tabList: [
        { lable: "全部", val: "all" },
        { lable: "免费", val: "0" },
        { lable: "付费", val: "1" },
      ],
      courseList: [
        // {logo: require("@/assets/img/recommend.svg"), title: "海滨少儿美术", info: "培养孩子爱国情怀，弘扬中华优秀课哈哈哈哈哈培养孩子爱国情怀",play:'18课时/学年',status:'免费', staion:'0'},
        // {logo: require("@/assets/img/recommend.svg"), title: "网球体育类", info: "好的Haui发挥未婚夫IHFi2222炯炯会我和空间环境跨境很好",play:'13课时/学年',status:'免费', staion:'1'},
        // {logo: require("@/assets/img/recommend.svg"), title: "海滨少儿美术", info: "培养孩子爱国情怀，弘扬中华优秀课哈哈哈哈哈培养孩子爱国情怀",play:'18课时/学年',status:'免费', staion:'0'},
        // {logo: require("@/assets/img/recommend.svg"), title: "网球体育类", info: "好的Haui发挥未婚夫IHFi2222炯炯会我和空间环境跨境很好",play:'13课时/学年',status:'免费', staion:'1'},
        // {logo: require("@/assets/img/recommend.svg"), title: "海滨少儿美术", info: "培养孩子爱国情怀，弘扬中华优秀课哈哈哈哈哈培养孩子爱国情怀",play:'18课时/学年',status:'￥2988', staion:'0'},
        // {logo: require("@/assets/img/recommend.svg"), title: "网球体育类", info: "好的Haui发挥未婚夫IHFi2222炯炯会我和空间环境跨境很好",play:'13课时/学年',status:'免费', staion:'1'},
        // {logo: require("@/assets/img/recommend.svg"), title: "海滨少儿美术", info: "培养孩子爱国情怀，弘扬中华优秀课哈哈哈哈哈培养孩子爱国情怀",play:'18课时/学年',status:'$68', staion:'0'},
        // {logo: require("@/assets/img/recommend.svg"), title: "网球体育类", info: "好的Haui发挥未婚夫IHFi2222炯炯会我和空间环境跨境很好",play:'13课时/学年',status:'免费', staion:'1'},
      ],
    };
  },
  watch: {},
  created() {
    this.getDataList();
  },
  methods: {
    dayjs,
    async getDataList() {
      let params = {
        typeId: this.queryParams.typeId,
        scope: this.queryParams.scope,
        project: this.queryParams.project,
        cost: this.queryParams.cost,
        schoolApply: "", //适用学校 all 所有 0优质学校，1普通学校，2薄弱学校
        objectApply: "", //适用对象 all 所有 0发达城市，1次发达城市，2一般城市
        pageSize: this.pageSize,
        pageNum: this.pageNum,
      };
      let res = await schoolApi.handleSystemList(params);
      if (res.result === "000000") {
        console.log("获取系统课程库列表---", res.data.list);
        this.courseList = res.data.list;
        this.totalPage = res.data.total;
      }
    },
    searchFun() {
      this.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.pageSize = val;
      this.getDataList();
    },
    currentChangeHandle(val) {
      this.pageNum = val;
      this.getDataList();
    },
    async toDetail(item) {
      this.detail.show = true;
      this.introduceState = item.introduceState;
      let params = {
        id: item.cid,
      };
      let { result, data } = await getDetail(params);
      console.log("获取课程详情---", data);
      if (result == "000000") {
        data.orgName = item.source;
        this.detail.info = data;
        this.detail.show = true;
      } else {
        this.$message({
          type: "error",
          message: "获取信息失败",
        });
      }
    },
    toIndex(type) {
      this.detail.show = false;
      this.getDataList();
    },
    // 引入
    importFun: _.throttle(
      function (item) {
        // 0未引入，1已引入
        if (item.introduceState == "1" || this.introduceState == "1") {
          this.cancelImportFun(item);
        } else if (item.introduceState == "0" || this.introduceState == "0") {
          this.importConfirm(item);
        }
      },
      3000,
      { leading: true, trailing: false }
    ),
    // 引入确认
    importConfirm(item) {
      util.handleCofirm("确定引入课程?", "info").then(async (res) => {
        let params = {
          cid: item.cid,
        };
        let { result } = await schoolApi.handleSystemIntroduce(params);
        if (result == "000000") {
          this.$message({
            type: "success",
            duration: 1500,
            message: "操作成功",
          });
          this.detail.show = false;
          this.getDataList();
        } else {
          this.$message({
            type: "error",
            duration: 1500,
            message: "操作失败",
          });
        }
      });
    },
    // 取消引入
    cancelImportFun(item) {
      util
        .handleCofirm("确定取消引入?", "info")
        .then(async (res) => {
          let params = {
            cid: item.cid,
          };
          let { result } = await schoolApi.schoolCourseCancelcourse(params);
          if (result == "000000") {
            this.$message({
              type: "success",
              duration: 1500,
              message: "操作成功",
            });
            this.detail.show = false;
            this.getDataList();
          } else {
            this.$message({
              type: "error",
              duration: 1500,
              message: "操作失败",
            });
          }
        })
        .catch((err) => {
          console.log("err", err); // cancel
        });
    },
    courseTypeClick(it) {
      this.pageNum = 1;
      this.queryParams.typeId = it.val;
      this.getDataList();
    },
    gradeClick(it) {
      this.pageNum = 1;
      this.queryParams.scope = it.val;
      this.getDataList();
    },
    courseSpecialClick(it) {
      this.pageNum = 1;
      this.queryParams.project = it.val;
      this.getDataList();
    },
    tabClick(it) {
      this.pageNum = 1;
      this.queryParams.cost = it.val;
      this.getDataList();
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.index {
  width: 100%;
  height: 100%;
  padding: 0 30px 30px;
  overflow: auto;
  .title {
    height: 60px;
    line-height: 48px;
    border-bottom: 1px solid #eaeaea;
    margin-bottom: 20px;
    display: flex;
    justify-content: flex-start;
    .span1 {
      font-family: "PingFang SC Bold";
      font-weight: bold;
      font-size: 20px;
      text-align: left;
      color: #000;
      margin-right: 30px;
    }
  }
  .selectBox {
    border-bottom: 1px solid #eaeaea;
    .selectRow {
      display: flex;
      justify-content: left;
      align-items: center;
      margin: 20px 10px;
      .selectLable {
        color: #888888;
        font-size: 14px;
      }
      .selectItem {
        margin: 0 10px;
        padding: 0 7px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        cursor: pointer;
        &.on {
          background: #0085ff;
          border-radius: 3px;
          color: #fff;
        }
      }
    }
  }
  .tab_box {
    width: 100%;
    height: 41px;
    background: #f9f9f9;
    border-radius: 8px;
    .selectRow {
      display: flex;
      justify-content: left;
      align-items: center;
      margin: 20px 10px;
      .selectItem {
        margin: 12px 20px;
        height: 28px;
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        color: #555555;
        cursor: pointer;
        &.on {
          font-family: "PingFang SC";
          font-style: normal;
          font-weight: 600;
          border-bottom: 1.5px solid #0085ff;
          color: #0085ff;
        }
      }
      .count {
        margin-left: 67%;
        margin-bottom: 13px;
        span {
          color: #0085ff;
        }
      }
    }
  }
  .course_box {
    width: 100%;
    display: flex;
    justify-content: left;
    align-items: center;
    flex-wrap: wrap;
    margin-top: 25px;
    .course_item {
      position: relative;
      width: 23%;
      height: 320px;
      margin: 0 1.5% 35px 0;
      .recommend {
        position: absolute;
        left: 80%;
        width: 45px;
        height: 21px;
      }
      img {
        width: 100%;
        height: 220px;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }
      .course_info {
        border: 1px solid #eaeaea;
        border-top: 0px;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        .title {
          height: 30px;
          padding-top: 5px;
          margin-left: 8px;
          margin-bottom: 0px;
          line-height: 30px;
          font-style: normal;
          font-weight: 600;
          font-size: 14px;
          color: #222222;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          border: 0px;
        }
        p {
          margin: 8px;
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .play {
          font-style: normal;
          font-weight: 400;
          font-size: 12px;
          margin: 8px;
          .play_time {
            color: #999999;
          }
          .play_status {
            float: right;
            color: #eb5757;
          }
        }

        .jion_btn {
          cursor: pointer;
          border-top: 1px solid #eaeaea;
          height: 35px;
          text-align: center;
          line-height: 35px;
          font-size: 12px;
          img {
            width: 12px;
            height: 12px;
            margin-right: 5px;
          }
        }
      }
    }
  }
  .no_data {
    margin: 4% 30%;
  }
  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
.confirm {
  .content {
    display: flex;
    justify-content: center;
  }
  .dialog-footer {
    margin-top: 30px;
  }
}
</style>
